/*
 * @Author: your name
 * @Date: 2019-11-21 18:30:51
 * @LastEditTime : 2019-12-31 14:17:13
 * @LastEditors  : Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mei_qi_zeroweb_endlyq/src/api/market.js
 */
/**
 * @Auther: Qsan
 * @Date：2018年12月12日 00:22
 * @Desc：营销应用相关接口
 */
import { get, post, put, deletes } from '@common/http'

// /wx/notify/getPreAuthCode

export const getPreAuthCode = param => get('/wx/notify/getPreAuthCode', param)

export const getTenantQueryAuth = param => get('/wx/notify/getTenantQueryAuth', param)

export const getTenantWxInfo = param => get('wx/notify/tenantWxInfo', param)

export const getActiveDataDictionary = param => get('wx/notify/tuwenStatisticalData', param) // 获取推送统计数据

export const getResend = param => get('/wx/notify/pushInfoAgain', param) // 再次发送
 // /tenantWxInfo
 export const pushNumber = param => get('tenant/wxPushCount', param) // 获取剩余推送次数

 export const upLoadImg = param => post('wx/notify/uploadImg', param)

// 获取当前商家绑定公众号
// /wx/auth-info
export const getWxAuthInfo = param => get('/wx/auth-info', param)

/**
 * 获取数据
 * @param param
 * @returns {*}
 */
export const getData = param => get('/getData', param)

/**
 * 添加数据
 * @param param
 * @returns {*}
 */
export const addData = param => post('/getData', param)

/**
 * 获取授权二维码
 * @param param
 * @returns {*}
 */
export const getAuthURL = param => post('/wechat-service/wx/web/getAuthURL', param)

/**
 * 根据授权码初始化授权
 * @param param
 * @returns {*}
 */
export const getAuthInfo = param => post('/wechat-service/wx/web/getAuthInfo', param)

/**
 * 获取公众号信息
 * @param param
 * @returns {*}
 */
export const getWechatInfo = param => post('/wechat-service/wx/web/getWechatInfo', param)

/**
 * 取消授权
 * @param param
 * @returns {*}
 */
export const cancelAuthInfo = param => post('/wx/notify/unbindWx', param)

/**
 * 消息设置
 * @param {*} param
 * @returns
 */
export const putNews = param => put('/tenant', param)

/**
 * 获取预约详情
 * @param {*} param
 * @returns
 */
export const bookingDetails = param => get('/t-appointment', param)

/**
 * 预约统计
 * @param {*} param
 * @returns
 */
export const statisticsData = param => post('/tenant/appointmentStatistical', param)

/**
 * 创建短信模板
 * @param {*} param
 * @returns
 */
export const putInfoTemplate = param => post('/t-template-sms', param)

/**
 * 获取短信模板
 * @param {*} param
 * @returns
 */

export const getInfoTemplate = param => get(`t-template-sms/getSmsList`, param)

/**
 * 群发短信
 * @param {*} param
 * @returns
 */
export const sendGroupMessage = ({ deductionAmount, mobileContentList, phoneNumber }) => post(`/tenant/sendMarketingP2PMessage?deductionAmount=${deductionAmount}&phoneNumber=${phoneNumber}`, mobileContentList)

/**
 * 删除短信
 * @param {*} param
 * @returns
 */
export const deleteSMSTemplate = id => deletes(`t-template-sms/${id}`)

/**
 * 相同短信群发功能
 * param {}
 * data {}
 * */
export const SendTheSameTextMessagesInGroups = ({ params, data }) => post(`/tenant/sendMarketingMessage?deductionAmount=${params.deductionAmount}&templateId=${params.templateId}&phoneNumber=${params.phoneNumber}`, data)

/**
 * 查询短信模板申请状态
 * get
 * */
export const smsGetStatus = () => get('/t-template-sms/getStatus')

/**
 *  查询模板是否可用
 * */

export const checkUSMSSensitiveWord = (param) => post('/t-template-sms/checkUSMSSensitiveWord', param)

// 获取消费类短信设置
export const getSmsConsumeSetUp = () => get('/tenant/getSmsConsumeSetUp')

// 修改消费类短信设置
export const updateSmsConsumeSetUp = (number) => put(`/tenant/updateSmsConsumeSetUp?status=${number}`)

// 获取当前充值是否成功
export const getSmsOrderStatus = (id) => get(`/order/getTextMassage?id=${id}`)

// 修改检测充值成功的状态
export const wxUpdateSmsStatus = (param) => put(`/order/wxUpdateSmsStatus?status=${param.status}&tenantId=${param.tenantId}`)

// 获取消费短信记录
export const tSmsRecord = (params) => get('/t-sms-record', params)

// 获取店铺营业时间段
export const accessToBusinessHours = () => get('/dict/getTenantDoBusinessSettings')

// 设置店铺营业时间
export const setStoreOpeningHours = data => put('/dict/modifyBusinessSettings', data)





// WEBPACK FOOTER //
// ./src/api/market.js